"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDynamicFormValidationSchema = void 0;
const Yup = __importStar(require("yup"));
/**
 * Validate phone number format
 */
const phoneRegExp = /\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}/;
const getDynamicFormValidationSchema = (config, validateModel) => {
    let baseSchema = Yup.object({
        email: Yup.string()
            .email(config.email.invalid)
            .when('preferredContactMethod', ([value], schema) => value === 'email' ||
            value === 'either'
            ? schema.required(config.email.required)
            : schema),
        firstName: Yup.string()
            .min(1, config.firstName.min)
            .required(config.firstName.required),
        lastName: Yup.string()
            .min(1, config.lastName.min)
            .required(config.lastName.required),
        phone: Yup.string()
            .matches(phoneRegExp, config.phone.invalid)
            .when('preferredContactMethod', ([value], schema) => value === 'phone' ||
            value === 'either'
            ? schema.required(config.phone.required)
            : schema),
        comments: Yup.string()
            .min(1, config.comments.min)
            .max(1000, config.comments.max)
    });
    if (validateModel) {
        const modelSchema = Yup.object({
            modelName: Yup.string().required(config.modelName.required),
            trim: Yup.string().required(config.trim.required)
        });
        baseSchema = baseSchema.concat(modelSchema);
    }
    return baseSchema;
};
exports.getDynamicFormValidationSchema = getDynamicFormValidationSchema;
